export const ICON_BASE_NAME = 'bringg-icon';
